module.exports = __webpack_public_path__ + "static/media/wmahsn_logo.ebb727e6.png";